import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import logo from './images/logo.png'; // Adjust the path if needed
import './Navbar.css'; // Import custom CSS for hover effect
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(true);

  const toggleNavbar = () => {
    setIsNavbarCollapsed(!isNavbarCollapsed);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light p-2">
      <div className="container">
        <Link className="navbar-brand" to="/" onClick={() => setIsNavbarCollapsed(true)}>
          <img className='logo' src={logo} alt="LG Industry Logo" /> 
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
          aria-controls="navbarNav"
          aria-expanded={!isNavbarCollapsed}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className={`collapse navbar-collapse ${isNavbarCollapsed ? '' : 'show'}`} id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item mx-2">
              <Link to="/" className="nav-link nav-hover" onClick={() => setIsNavbarCollapsed(true)}>
                Home
              </Link>
            </li>
            <li className="nav-item mx-2">
              <Link to="/about" className="nav-link nav-hover" onClick={() => setIsNavbarCollapsed(true)}>
                About us
              </Link>
            </li>
            <li className="nav-item dropdown mx-2">
              <a
                className="nav-link dropdown-toggle nav-hover"
                href="#products"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Our Products
              </a>
              <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                <li>
                  <Link className="dropdown-item" to="/crumbrubber" onClick={() => setIsNavbarCollapsed(true)}>
                    Crumb Rubber
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/epdm" onClick={() => setIsNavbarCollapsed(true)}>
                    EPDM Granules
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/TyreWire" onClick={() => setIsNavbarCollapsed(true)}>
                    Tyre Wire
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item mx-2">
              <Link className="nav-link nav-hover" to="/enquiry" onClick={() => setIsNavbarCollapsed(true)}>
                Enquiry
              </Link>
            </li>
            <li className="nav-item mx-2">
              <Link className="nav-link nav-hover" to="/contact" onClick={() => setIsNavbarCollapsed(true)}>
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
